import { BIG_CHANGE_RATIO, FIELDS } from './constants'

export const getIn = (obj, path) =>
  path.reduce((acc, key) => (acc == null ? undefined : acc[key]), obj)

export const setIn = (obj, [key, ...rest], value) => ({
  ...obj,
  [key]: rest.length ? setIn(obj?.[key] ?? {}, rest, value) : value
})

const DECIMAL_PATTERN = /^\d+(\.\d+)?$/

export const parseDecimal = text => {
  const normalized = String(text ?? '').trim().replace(',', '.')
  return DECIMAL_PATTERN.test(normalized) ? Number(normalized) : NaN
}

export const formatDecimal = value =>
  typeof value === 'number' && !Number.isNaN(value)
    ? value.toLocaleString('es-UY', { maximumFractionDigits: 6, useGrouping: false })
    : ''

export const formatMoney = (value, currency) => {
  if (value == null || Number.isNaN(value)) return '—'
  const symbol = currency === 'UYU' ? '$' : currency === 'USD' ? 'US$' : 'ARS'
  return `${symbol} ${value.toLocaleString('es-UY')}`
}

export const formatPercent = ratio =>
  `${ratio > 0 ? '+' : ''}${(ratio * 100).toLocaleString('es-UY', {
    maximumFractionDigits: 1
  })}%`

export const draftFromConfig = config =>
  Object.fromEntries(FIELDS.map(field => [field.id, formatDecimal(getIn(config, field.path))]))

export const validateField = (field, value) => {
  if (Number.isNaN(value)) return 'Ingresá un número válido'
  if (field.kind === 'price' && value <= 0) return 'Tiene que ser mayor a 0'
  if (field.kind === 'multiplier' && value < 1) return 'Tiene que ser 1 o más'
  return null
}

export const describeField = (field, saved, draft) => {
  const previous = getIn(saved, field.path)
  const text = draft[field.id]
  const value = parseDecimal(text)
  const changed = Number.isNaN(value) ? text !== formatDecimal(previous) : value !== previous
  const error = changed ? validateField(field, value) : null
  const ratio =
    changed && !error && typeof previous === 'number' && previous > 0
      ? (value - previous) / previous
      : null
  return {
    previous,
    value,
    changed,
    error,
    ratio,
    bigChange: ratio != null && Math.abs(ratio) >= BIG_CHANGE_RATIO
  }
}

export const buildPayload = (saved, draft) =>
  FIELDS.reduce((config, field) => {
    const { changed, error, value } = describeField(field, saved, draft)
    return changed && !error ? setIn(config, field.path, value) : config
  }, saved)

const adjustKmPriceForShortDistances = (kmPrice, distance) =>
  kmPrice + kmPrice * 2 * Math.exp(-0.025 * distance)

export const calcExample = (kmPrice, distance, round, multiplier) => {
  if (!distance || !(kmPrice > 0)) return null
  const price =
    Math.round((adjustKmPriceForShortDistances(kmPrice, distance) * distance) / round) * round
  const maxPrice = multiplier >= 1 ? Math.round((price * multiplier) / round) * round : null
  return { price, maxPrice }
}

export const normalizeSearch = text =>
  String(text ?? '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim()
